// Actions
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
/**
 * Action dispatched when Trouter registration succeeds.
 * Contains the full connection info from Trouter callback.
 */ export class TrouterRegistrationSucceededAction extends TypedAction(ActionType.TrouterRegistrationSucceededAction) {
    loggingData() {
        return {
            endpointUrl: this.endpointUrl,
            connectionId: this.connectionInfo.connectionId,
            connectionTtlSec: String(this.connectionInfo.connectionTtlSec),
            clientId: this.connectionInfo.clientId
        };
    }
    constructor(endpointUrl, connectionInfo, connectedAt){
        super(), this.endpointUrl = endpointUrl, this.connectionInfo = connectionInfo, this.connectedAt = connectedAt;
    }
}
/**
 * Action dispatched when Trouter registration fails
 */ export class TrouterRegistrationFailedAction extends TypedAction(ActionType.TrouterRegistrationFailedAction) {
    loggingData() {
        return {
            errorCode: this.errorCode
        };
    }
    constructor(errorCode, errorMessage){
        super(), this.errorCode = errorCode, this.errorMessage = errorMessage;
    }
}
/**
 * Action dispatched when Trouter WebSocket connection is disconnected
 */ export class TrouterDisconnectedAction extends TypedAction(ActionType.TrouterDisconnectedAction) {
}
/**
 * Action dispatched when a Trouter subscription succeeds
 */ export class TrouterSubscriptionSuccessAction extends TypedAction(ActionType.TrouterSubscriptionSuccessAction) {
    loggingData() {
        return {
            viewUpdateKey: this.viewUpdateKey,
            scopeEntityId: this.scopeEntityId,
            queryType: this.queryType
        };
    }
    constructor(viewUpdateKey, scopeEntityId, queryType){
        super(), this.viewUpdateKey = viewUpdateKey, this.scopeEntityId = scopeEntityId, this.queryType = queryType;
    }
}
/**
 * Action dispatched when a Trouter subscription fails
 */ export class TrouterSubscriptionFailedAction extends TypedAction(ActionType.TrouterSubscriptionFailedAction) {
    loggingData() {
        return {
            scopeEntityId: this.scopeEntityId,
            queryType: this.queryType,
            errorCode: this.errorCode,
            shouldRetry: String(this.shouldRetry),
            retryAfterSeconds: this.retryAfterSeconds?.toString() ?? ""
        };
    }
    constructor(scopeEntityId, queryType, errorCode, shouldRetry, retryAfterSeconds){
        super(), this.scopeEntityId = scopeEntityId, this.queryType = queryType, this.errorCode = errorCode, this.shouldRetry = shouldRetry, this.retryAfterSeconds = retryAfterSeconds;
    }
}
/**
 * Action dispatched when a Trouter notification is received for a subscription
 */ export class TrouterNotificationReceivedAction extends TypedAction(ActionType.TrouterNotificationReceivedAction) {
    loggingData() {
        return {
            queryType: this.queryType,
            scopeEntityId: this.scopeEntityId
        };
    }
    constructor(queryType, scopeEntityId, receivedAt){
        super(), this.queryType = queryType, this.scopeEntityId = scopeEntityId, this.receivedAt = receivedAt;
    }
}
